<template>
  <page-header-wrapper>
    <div slot="extra">
      <a-button v-action:add type="primary" icon="plus" @click="handleCreate()">
        新建合作伙伴
      </a-button>
    </div>
    <a-card :bordered="false" class="ant-pro-components-tag-select">
      <a-form layout="inline">
        <standard-form-row block>
          <div class="ant-pro-page-header-search">
            <a-input-search
              size="large"
              style="width: 80%; max-width: 522px;"
              v-model="params.where.name"
              placeholder="请输入名称"
              enter-button
              @search="getLists()"
            />
            <a-button type="link" @click="() => (this.search = !this.search)">高级筛选<a-icon :type="search ? 'up' : 'down'" /></a-button>
          </div>
        </standard-form-row>
        <template v-if="search">
          <standard-form-row title="排序" grid>
            <a-row>
              <a-col :lg="20" :md="20" :sm="24" :xs="24">
                <a-form-item :wrapper-col="{ sm: { span: 20 }, xs: { span: 24 } }">
                  <a-radio-group v-model="orderID" @change="handleChangeOrder">
                    <a-radio-button value="id">
                      ID
                    </a-radio-button>
                    <a-radio-button value="order">
                      排序
                    </a-radio-button>
                    <a-radio-button value="created_at">
                      创建时间
                    </a-radio-button>
                    <a-radio-button value="updated_at">
                      修改时间
                    </a-radio-button>
                  </a-radio-group>
                </a-form-item>
              </a-col>
              <a-col :lg="4" :md="4" :sm="24" :xs="24">
                <a-form-item :wrapper-col="{ sm: { span: 24 }, xs: { span: 24 } }">
                  <a-select
                    placeholder="不限"
                    v-model="orderVal"
                    style="width: 120px"
                    @change="handleChangeOrder"
                  >
                    <a-select-option value="asc">
                      升序
                    </a-select-option>
                    <a-select-option value="desc">
                      降序
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
          </standard-form-row>
          <standard-form-row title="创建日期" block>
            <a-form-item :wrapper-col="{ sm: { span: 8 }, xs: { span: 24 } }">
              <a-range-picker
                :ranges="{
                  最近七天: [moment().subtract('days', 6), moment()],
                  今天: [moment(), moment()],
                  本月: [moment().startOf('month'), moment()]
                }"
                :placeholder="['开始日期', '结束日期']"
                @change="values => handleChangeDate(values)"
              />
            </a-form-item>
          </standard-form-row>
        </template>
      </a-form>
    </a-card>

    <div class="ant-pro-pages-list-projects-cardList">
      <div slot="operate" class="change-state">
        <a-radio-group @change="searchChangeState">
          <a-radio-button value="0">全部</a-radio-button>
          <a-radio-button value="1">展示</a-radio-button>
          <a-radio-button value="2">隐藏</a-radio-button>
        </a-radio-group>

        <!-- <a-button type="default" icon="edit">
          批量管理
        </a-button> -->
      </div>
      <a-list
        :loading="loading"
        :data-source="list"
        :grid="{ gutter: 24, xl: 4, lg: 3, md: 3, sm: 2, xs: 1 }"
        :pagination="pagination"
      >
        <a-list-item slot="renderItem" slot-scope="item">
          <a-card class="ant-pro-pages-list-projects-card" hoverable>
            <viewer slot="cover" class="cover-pic">
              <img :src="globalUrl + item.logo" :key="item.name" />
            </viewer>
            <a-card-meta :title="item.name">
              <template slot="description">
                <ellipsis :length="50">{{ item.href }}</ellipsis>
              </template>
            </a-card-meta>
            <div class="cardItemContent">
              <span
              >排序：<b style="color:red">{{ item.order }}</b></span
              >
              <span
              >合作伙伴类型： <a-tag color="blue">{{ item.partnerType == '1' ? '合作伙伴' : '优秀合作伙伴' }}</a-tag>
              </span
              >
              <span>创建时间：{{ moment(item.created_at).fromNow() }}</span>
              <span>上次修改：{{ moment(item.updated_at).fromNow() }}</span>
            </div>
            <template slot="actions">
              <a-tooltip title="编辑" v-action:update @click="() => handleEdit(item.id)">
                <a-icon type="edit" />
              </a-tooltip>

              <a-tooltip title="删除" v-action:delete>
                <a-popconfirm
                  title="确定要删除该友链吗？"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="handleOnDelete(item.id)"
                >
                  <a-icon type="delete" />
                </a-popconfirm>
              </a-tooltip>
              <a-tooltip title="修改状态" v-action:state>
                <a-switch :checked="item.state === 1" @change="handleChangeState(item.id)">
                  <a-icon slot="checkedChildren" type="check" />
                  <a-icon slot="unCheckedChildren" type="close" />
                </a-switch>
              </a-tooltip>
            </template>
          </a-card>
        </a-list-item>
      </a-list>
    </div>
  </page-header-wrapper>
</template>

<script>
import { list, card } from '@/mixins' // 引入
import { TagSelect, StandardFormRow, Ellipsis, AvatarList } from '@/components'
import ModelForm from './modules/ModelForm'
const TagSelectOption = TagSelect.Option
const AvatarListItem = AvatarList.AvatarItem
const apiList = {
    getList: '/partners/links',
    changeState: '/partners/links/',
    delete: '/partners/links/'
}

export default {
    name: 'LinksList',
    mixins: [list, card], // 使用mixins
    components: {
        ModelForm,
        AvatarList,
        AvatarListItem,
        Ellipsis,
        TagSelect,
        TagSelectOption,
        StandardFormRow
    },
    data () {
        return {
            apiList
        }
    },
    mounted () {
        this.getLists() // 获取广告位列表
    },
    methods: {
        /**
         * 弹窗添加友链
         * ModelForm
         */
        handleCreate () {
            const that = this
            that.$dialog(
                ModelForm,
                // component props
                {
                    record: {},
                    on: {
                        ok () {
                            that.getLists()
                        }
                    }
                },
                // modal props
                {
                    title: '新建合作伙伴',
                    centered: true,
                    width: 700,
                    maskClosable: true,
                    okText: '提交',
                    cancelText: '关闭'
                }
            )
        },
        /**
         * 弹窗编辑友链
         * ModelForm
         */
        handleEdit (aid) {
            const that = this
            that.$dialog(
                ModelForm,
                {
                    aid,
                    on: {
                        ok () {
                            that.getLists()
                        }
                    }
                },
                // modal props
                {
                    title: '编辑合作伙伴',
                    centered: true,
                    maskClosable: true,
                    okText: '提交',
                    width: 700,
                    cancelText: '关闭'
                }
            )
        }
    }
}
</script>
